// extracted by mini-css-extract-plugin
export var contentBody = "_ca-9";
export var headerImage = "_ca-2";
export var imageButton = "_ca-7";
export var imageButtonIcon = "_ca-8";
export var imageHeader = "_ca-4";
export var imageHeaderText = "_ca-5";
export var imageOverlay = "_ca-3";
export var imageTitle = "_ca-6";
export var imageWrapper = "_ca-1";
export var taskList = "_ca-a";
export var widget = "_ca-0";